import React, { useState, useEffect } from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import CollectOrderService from "../../../services/CollectOrderService";
import MinorCollectOrderDetails from "../../molecules/MinorCollectOrderDetails";

export default function AcertoModal({
  isModalOpen,
  setModalOpen,
  collectOrderId,
  requestNro,
  // setTicketCb
}) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm();

  const [collectOrderObject, setCollectOrderObject] = useState();

  useEffect(() => {
    async function fetchRequest() {
      const cOrder = await CollectOrderService.getCollectOrdersById(
        collectOrderId
      );
      setCollectOrderObject(cOrder);
    }

    fetchRequest();
  }, [isModalOpen]);

  const onSubmit = async (data) => {

    const body = { 
      status: "ACERTO",
      motivoAcerto: data.motivoAcerto,
      id: collectOrderId
    };

    try {
      await CollectOrderService.updateParcial(collectOrderId, body);
      console.log(body)
      toast.success("Marcado como Acerto Contábil!");
    } catch (error) {
      toast.error(error.message);
    }

    setModalOpen(!isModalOpen);
    reset();
  
  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
    reset();
  };

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col w-[648px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all mt-6" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 text-left gap-2 bg-amber-600 rounded-t-lg">
                <div className="text-white text-xl font-bold mt-4">
                  ACERTO CONTÁBIL
                </div>
                <div className="flex justify-between">
                  <div className="text-white text-sm px-4">
                    Coleta:{" "}
                    {collectOrderObject?.collectOrder.idCollectOrder}
                  </div>
                  <div className="text-white text-sm px-4">
                    Ref Solicitação:{" "}
                    {collectOrderObject?.collectOrder.idRequest}
                  </div>
                </div>
              </div>

              <MinorCollectOrderDetails collectOrder={collectOrderObject?.collectOrder} />

              {/* MODAL FORM BEGIN */}
              <div className="flex flex-col mt-6 px-6">
                <div className="w-full relative inline-block text-left">
                  <div className="w-full flex flex-col text-sm gap-4">
                    <div className="flex flex-col items-start gap-1 mb-2 w-full">

                    <div className="flex flex-col items-start gap-1 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                        Motivo Acerto Contábil:
                      </label>
                      <input
                        type="text"
                        {...register("motivoAcerto", {
                          required: true,
                        })}
                        className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                        ${
                          errors?.motivoAcerto?.type === "required"
                            ? " border border-red-500 outline-none ring-0"
                            : "border border-zinc-500 outline-none ring-0"
                        }
                        `}
                      />
                      {errors?.motivoAcerto?.type === "required" && (
                        <p className="text-red-500 text-xs ms-2">
                          Campo obrigatório
                        </p>
                      )}
                    </div>


                      <div className="w-1/5 block text-gray-700 font-bold whitespace-nowrap mt-2">
                        Deseja marcar como ACERTO CONTÁBIL?
                      </div>
                      <div className="w-1/5 block text-red-700 italic whitespace-nowrap text-xs">
                        Esta ação não pode ser desfeita e o saldo devedor do técnico será ajustado.
                      </div>
                    </div>

                    <div className="flex gap-4">
                      <button
                        onClick={() => handleSubmit(onSubmit)()}
                        className="w-full bg-amber-600 text-white py-2 px-4 rounded-md hover:bg-amber-800"
                      >
                        Sim
                      </button>

                      <button
                        onClick={() => setModalOpen(!isModalOpen)}
                        className="w-full bg-neutral-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}
